export default "__VITE_ASSET__e3gb2RI6__"